import {quickSlice} from "../../../../setup/redux/slice/quickSlice";
import {basedApiMock} from "../../../../../_the_law/_helpers/forApiMock";

export const trademarkSlice = quickSlice({
    name: "trademarks",
    endpoint: basedApiMock("trademarks", "trademark")
});
